import MasterTab from 'src/components/Layouts/MasterTab.vue';
import ProfitExportedBoxes from "src/views/Pages/Dashboard/Grow/Reports/ProfitExportedBoxes/ProfitExportedBoxes.vue";
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';

const ProfitExportedBoxesRoutes = {
  path: 'grow',
  name: 'grow.grow',
  component: MasterTab,
  props: { reference: 'growTabs' },
  children: [
    {
      path: 'profitexportedboxes',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'grow.profit_exported_boxes',
          component: ProfitExportedBoxes,
          meta: {
            prefix_permission: 'grow_profitexportedboxes',
          },
        },
      ],
    },
  ],
};

export default ProfitExportedBoxesRoutes;